import { Resolvers } from '@apollo/client';
import { InMemoryResolver } from '../../utils/ApolloUtils';
import { IUpdateTravelPeriodDatesDraftVariables } from './BookingAmendments.mutations';
import { GET_FILTERS_DATA, ITravelPeriodData } from './BookingAmendments.queries';

const DEFAULT_TRAVEL_PERIOD: ITravelPeriodData = {
  travelPeriod: {
    __typename: 'TravelPeriod',
    endDate: null,
    hasInitialisedData: false,
    startDate: null,
  },
  travelPeriodDraft: {
    __typename: 'TravelPeriodDraft',
    endDate: null,
    startDate: null,
  },
};

const undoTravelPeriodChanges: InMemoryResolver<{}> = (_, __, { cache }) => {
  const { travelPeriod, ...rest } = cache.readQuery({
    query: GET_FILTERS_DATA,
  });

  const data: ITravelPeriodData = {
    ...rest,
    travelPeriod,
    travelPeriodDraft: travelPeriod,
  };

  cache.writeQuery({ data, query: GET_FILTERS_DATA });

  return null;
};

const updateTravelPeriodDatesDraft: InMemoryResolver<IUpdateTravelPeriodDatesDraftVariables> = (
  _,
  { endDate, startDate },
  { cache }
) => {
  const { travelPeriod, travelPeriodDraft } = cache.readQuery({
    query: GET_FILTERS_DATA,
  });

  const newEndDate: string = endDate ? endDate.toISOString() : travelPeriodDraft.endDate;
  const newStartDate: string = startDate ? startDate.toISOString() : travelPeriodDraft.startDate;

  const data: ITravelPeriodData = {
    travelPeriod,
    travelPeriodDraft: {
      ...travelPeriodDraft,
      endDate: newEndDate,
      startDate: newStartDate,
    },
  };

  cache.writeQuery({ data, query: GET_FILTERS_DATA });

  return null;
};

const resetTravelPeriod: InMemoryResolver<{}> = (_, __, { cache }) => {
  const { travelPeriod, travelPeriodDraft } = DEFAULT_TRAVEL_PERIOD;

  cache.writeQuery({
    data: {
      travelPeriod: {
        ...travelPeriod,
        hasInitialisedData: true,
      },
      travelPeriodDraft: {
        ...travelPeriodDraft,
      },
    },
    query: GET_FILTERS_DATA,
  });

  return null;
};

export const resolvers: Resolvers = {
  Mutation: {
    resetTravelPeriod,
    undoTravelPeriodChanges,
    updateTravelPeriodDatesDraft,
  },
};

export { DEFAULT_TRAVEL_PERIOD };
